import { render, staticRenderFns } from "./ResetCompleteModal.vue?vue&type=template&id=2c2c92c4&scoped=true"
import script from "./ResetCompleteModal.vue?vue&type=script&lang=ts"
export * from "./ResetCompleteModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2c92c4",
  null
  
)

export default component.exports